import {
  BaseCurrency,
  DepositPaymentTargetAccount,
  GetDepositPaymentDetailsResponse,
  Loadable,
  LoadableState,
} from '@eih-netbroker/common';
import { atom } from 'jotai';

export const depositDetailsAtom = atom<LoadableState<GetDepositPaymentDetailsResponse>>(Loadable.uninitialized);
export const targetAccountsAtom = atom<LoadableState<Array<DepositPaymentTargetAccount>>>(Loadable.uninitialized);
export const selectedTargetAccountAtom = atom<DepositPaymentTargetAccount | undefined>(undefined);

export const internalDepositSelectedCurrencyAtom = atom<string>(BaseCurrency);
export const externalDepositSelectedCurrencyAtom = atom<string>(BaseCurrency);
